import { Grid, Switch } from '@mui/material'
import { useIntl } from 'react-intl'

import { SettingsControlSection } from '../SettingsComponent/SettingsComponent'

export default function SettingsMFA(props) {
  const intl = useIntl()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} data-cy='mfa_required'>
        <SettingsControlSection
          {...props}
          id='mfa_required'
          label={intl.formatMessage({
            id: 'settings.sectionControlLabels.mfa.requireMFA',
          })}
          ControlComponent={Switch}
        />
      </Grid>
    </Grid>
  )
}
